<template>
  <div class='piramide-slider'>
    <div class="close--overlay" 
      v-if="isOverlay"
      @click="() => transition(false)"
    >
      <img src="../assets/close-pyramid-arrow.svg" />
      <span>chat</span>
    </div>
    <PyramidSliderGlobal 
      :startPyramidSlider="startPyramidSlider"
      :startPyramidSliderGlobal="startPyramidSliderGlobal"
      :isOverlay="isOverlay"
    />
    <PyramidSliderMediterranean 
      :startPyramidSliderMediterranean="startPyramidSliderMediterranean"
      :isOverlay="isOverlay"
    />
    <PyramidSliderLatam 
      :startPyramidSliderLatam="startPyramidSliderLatam"
      :isOverlay="isOverlay"
    />
    <PyramidSliderAfrica 
      :startPyramidSliderAfrica="startPyramidSliderAfrica"
      :isOverlay="isOverlay"
    />
    <PyramidSliderAfrica 
      :startPyramidSliderAfrica="startPyramidSliderAfrica"
      :isOverlay="isOverlay"
    />
    <PyramidSliderSouthAsia 
      :startPyramidSliderSouthAsia="startPyramidSliderSouthAsia"
      :isOverlay="isOverlay"
    />
    <PyramidSliderEastAsia 
      :startPyramidSliderEastAsia="startPyramidSliderEastAsia"
      :isOverlay="isOverlay"
    />
    <PyramidSliderNordic 
      :startPyramidSliderNordic="startPyramidSliderNordic"
      :isOverlay="isOverlay"
    />
    <PyramidSliderUsa 
      :startPyramidSliderUsa="startPyramidSliderUsa"
      :isOverlay="isOverlay"
    />
    <div id="select-wrap">
      <label for="pyramid-select">
        {{
          this.$i18n.locale == 'it' ?
          "Seleziona un'area"
          :
          "Select to discover"
        }}
      </label>
      <div class="select">
        <select id="pyramid-select" @change="changePyramid($event)">
          <option value="global">
            {{
              this.$i18n.locale == 'it' ?
              "Globale"
              :
              "Global"
            }}
          </option>
          <option value="mediterranean">
            {{
              this.$i18n.locale == 'it' ?
              "Mediterraneo"
              :
              "Mediterranean"
            }}
          </option>
          <option value="east-asia">
            {{
              this.$i18n.locale == 'it' ?
              "Asia Orientale"
              :
              "East Asia"
            }}
          </option>
          <option value="latam">
            {{
              this.$i18n.locale == 'it' ?
              "America Latina"
              :
              "Latin America"
            }}
          </option>
          <option value="africa">Africa</option>
          <option value="south-asia">
            {{
              this.$i18n.locale == 'it' ?
              "Asia Meridionale"
              :
              "South Asia"
            }}
          </option>
          <option value="nordic">
            {{
              this.$i18n.locale == 'it' ?
              "Paesi Nordici & Canada"
              :
              "Nordics & Canada"
            }}
          </option>
          <option value="usa">USA</option>
        </select>
      </div>
    </div>
    
    <div class="cta-end-pyramids" @click="showResults">
      {{
        this.$i18n.locale == 'it' ?
        "Ho finito"
        :
        "I'm finished"
      }}
    </div>
    <div class="final--result-wrap">
      <div class="final--result">
        <div class="balloon">
          <p>
            The Health and Climate Pyramids show that foods that promote our health and should be eaten more frequently are generally also those with a lower environmental impact.
            <br /><br />
            This is why, in a world that has to face an ecological crisis, our decisions about food will make a difference! 
          </p>
        </div>
        <div class="avatar--res">
          <img src="../assets/cards-game/planet-happy.svg"/>
        </div>
        <div class="cta-badge-pyramid" @click="openBadgeOverlay">
          {{
            this.$i18n.locale == 'it' ?
            "OK, ho capito!"
            :
            "OK,got it!"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {preloadImages} from '../preload.js'
import {gsap, TimelineMax} from 'gsap'
import FullPyramid from './PyramidSvg.vue'
import PyramidSliderGlobal from './PyramidSliderGlobal.vue'
import PyramidSliderMediterranean from './PyramidSliderMediterranean.vue'
import PyramidSliderLatam from './PyramidSliderLatam.vue'
import PyramidSliderAfrica from './PyramidSliderAfrica.vue'
import PyramidSliderSouthAsia from './PyramidSliderSouthAsia'
import PyramidSliderEastAsia from './PyramidSliderEastAsia'
import PyramidSliderUsa from './PyramidSliderUsa'
import PyramidSliderNordic from './PyramidSliderNordic'

export default {
  name: 'PyramidsSlider',
  props: ['isOverlay', 'startPyramidSlider'],
  components:{
    PyramidSliderGlobal,
    PyramidSliderMediterranean,
    PyramidSliderLatam,
    PyramidSliderAfrica,
    PyramidSliderSouthAsia,
    PyramidSliderEastAsia,
    PyramidSliderUsa,
    PyramidSliderNordic
  },
  data(){
    return {
      currentPyramid: 'global',
      startPyramidSliderMediterranean: false,
      startPyramidSliderGlobal: false,
      startPyramidSliderLatam: false,
      startPyramidSliderAfrica: false,
      startPyramidSliderSouthAsia: false,
      startPyramidSliderEastAsia: false,
      startPyramidSliderUsa: false,
      startPyramidSliderNordic: false
    }
  },
  methods:{

    transition(val){
      
      if(val === false){
        gsap.to('.piramide-wrap', {duration: .75, left: '-100%', ease: 'Power2.easeInOut', 
          onComplete: () => {
            this.$store.dispatch('openOverlay', '')
            this.$store.dispatch('setMenuCtaVisibility',true);
            this.$store.dispatch('triggerReply')
          }
        })
      }
    },
    openBadgeOverlay(){
      this.$store.dispatch('openBadge', 'pyramid')
    },
    showResults(){
      gsap.set('.piramide-slider .final--result-wrap', {opacity: 1})
      gsap.to('.piramide-content--wrap', {duration: .75, left: '-100%', ease: 'Power2.easeInOut'})
      gsap.to('.cta-end-pyramids', {delay: 0.5, autoAlpha:0,duration: .5})
      gsap.to('.piramide-slider .final--result-wrap', 
        {
          duration: .75, x: '0%', autoAlpha: 1, ease: 'Power2.easeInOut',
          onComplete: () => {
            gsap.to('.piramide-slider .balloon',{duration: .5, delay: .5, autoAlpha: 1, ease: 'Power2.easeInOut'})
            gsap.to('.piramide-slider .avatar--res',{duration: .5, delay: .75, opacity:1, x: 0, ease: 'Power2.easeInOut'})
            gsap.to('.cta-badge-pyramid',{duration: .5, delay: 1, opacity:1, ease: 'Power2.easeInOut'})
          }
        
        })
    },
    changePyramid(e){

      
      let newPyramid = e.target.value
      let TL = gsap.timeline();
      TL
        .set('.piramide-arrow--wrap', {autoAlpha: 1,duration: .75})
        .to('.cta-end-pyramids', {autoAlpha:0,duration: .5})
        .to('.piramide-aside--wrap', {left: 0, top: 0, flex: window.innerWidth > 767 ? '0 0 25%' : '0 0 35%', maxWidth: window.innerWidth > 767 ? '25%' : '100%', duration: .75}, '-=.5')
        .to('.piramide-content--wrap', {flex: window.innerWidth > 767 ? '0 0 75%' : '0 0 65%', maxWidth: window.innerWidth > 767 ? '75%' : '100%', duration: .75, onComplete: () => {
            gsap.to(`.pyramid-${this.currentPyramid}`,{left: '-100%', onComplete: () => {
            gsap.set(`.pyramid-${this.currentPyramid}`, {left: '100%'})
            this.currentPyramid = newPyramid

            if(this.currentPyramid === 'mediterranean') this.startPyramidSliderMediterranean = false;
            if(this.currentPyramid === 'global') this.startPyramidSliderGlobal = false;
            if(this.currentPyramid === 'latam') this.startPyramidSliderGlobal = false;
            if(this.currentPyramid === 'africa') this.startPyramidSliderAfrica = false;
            if(this.currentPyramid === 'south-asia') this.startPyramidSliderSouthAsia = false;
            if(this.currentPyramid === 'east-asia') this.startPyramidSliderEastAsia = false;
            if(this.currentPyramid === 'nordic') this.startPyramidSliderNordic = false;
            if(this.currentPyramid === 'usa') this.startPyramidSliderUsa = false;
          }})
          gsap.to(`.pyramid-${newPyramid}`,{left: '0%', onComplete: () => {
            if(newPyramid === 'mediterranean') this.startPyramidSliderMediterranean = true;
            if(newPyramid === 'global') this.startPyramidSliderGlobal = true;
            if(newPyramid === 'latam') this.startPyramidSliderLatam = true;
            if(newPyramid === 'africa') this.startPyramidSliderAfrica = true;
            if(newPyramid === 'south-asia') this.startPyramidSliderSouthAsia = true;
            if(newPyramid === 'east-asia') this.startPyramidSliderEastAsia = true;
            if(newPyramid === 'nordic') this.startPyramidSliderNordic = true;
            if(newPyramid === 'usa') this.startPyramidSliderUsa = true;
          }})
          
        }}, '-=.5')

      // "nordics-canada"
      // "usa"

    }
  },
  mounted(){
    
		if(!this.isOverlay) {
      this.$store.dispatch('setMenuCtaVisibility',true);
    }
	
  },
 
}
</script>

<style lang="scss">
  .piramide-slider{
    position: absolute;
    top: 0;
    left: 100%;
    height: 100%;
    width: 100%;
    overflow: hidden;
    z-index: 4;
    &.overlayed{
      position: fixed;
      left: -100%;
    }
    .close--overlay{
      span{
        color: #000;
      }
    }
    @media screen and (max-width: 767px){
      flex-direction: column;
      overflow: visible;
    }
    .final--result-wrap{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      opacity: 0;
      background-position: 50%;
      background-image: url('../assets/section-bg-pyramid.jpg');
      transform: translateX(100%);
      visibility: hidden;
    }
    .final--result{
      position: relative;
      top: 60px;
      margin: 0 auto;
      background-size: cover;
      height: auto;
      width: 80%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      z-index: 3;
      .balloon{
        align-self: stretch;
        padding: 50px 20px;
        background-color: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;
        font-size: 32px;
        opacity: 0;
        margin-bottom: 20px;
      }
      .avatar--res{
        position: absolute;
        bottom: 0;
        transform: translate(-100%, 50%);
        left: 0;
        opacity: 0;
        margin: 0;
        width: 200px;
        img{
          display: block;
          width: 100%;
        }
      }
      .cta-badge-pyramid{
        text-align: right;
        margin: 20px 0 0 auto;
        border: 1px solid #2E70E2;
        background-color: #2E70E2;
        color: #fff;
        padding: 16px 20px;
        font-size: 24px;
        border-radius: 5px;
        cursor: pointer;
        opacity: 0;
      }
      @media screen and (max-width: 768px) {

        .balloon{
          padding: 20px;
          font-size: 18px;
          line-height: 24px;
        }
        .cta-badge-pyramid{
          font-size: 18px;
        }
        .avatar--res{
          width: 100px;
        }
      }
    }
  }
  #select-wrap{
    position: absolute;
    bottom: 40px;
    right: 30px;
    text-align: right;
    opacity: 0;
    label{
      font-size: 12px;
      line-height: 32px;
      
    }
    @media screen and (max-width: 767px){
      bottom: 20px;
      right: 20px;
    }
  }
  select {
  // A reset of styles, including removing the default dropdown arrow
    position: relative;
    appearance: none;
    background-color: transparent;
    outline: none;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    font-family: inherit;
    line-height: inherit;
    border: 1px solid #000;
    font-size: 20px;
    line-height: 24px;
    padding: 20px 24px;
    border-radius: 5px;
    min-width: 170px;
    @media screen and (max-width: 767px){
      font-size: 14px;
      padding: 10px;
    }
  }
  .select{
    position: relative;
  }
  .select::after {
    content: '';
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url('../assets/arrow-select.svg');
    width: 16px;
    height: 8px;
    background-size: 16px 8px;
    @media screen and(max-width: 768px) {
      right: 8px;
    }
  }

  select::-ms-expand {
    display: none;
  }
 .cta-end-pyramids{
  position: absolute;
  bottom: 40px;
  left: 30px;
  display: inline-block;
  text-align: right;
  margin: 20px 0 0 auto;
  border: 1px solid #2E70E2;
  background-color: #2E70E2;
  color: #fff;
  padding: 16px 20px;
  font-size: 24px;
  border-radius: 5px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    bottom: 20px;
    left: 20px;
    padding: 13px 15px;
  }
 }
</style>